import { ChangeEvent, RefObject, useEffect, useRef, useState } from 'react'
import clsx from 'clsx'
import SmileEmoji from 'shared/icons/SmileEmoji'
import EmojiPicker from 'emoji-picker-react'
import Loader from 'App/Loader'
import SendBold from 'shared/icons/SendBold'
import AttachFile from 'shared/icons/AttachFile'

interface MessageInputProps {
  className?: string
  id?: string
  placeholder?: string
  inputText:string
  setInputText: React.Dispatch<React.SetStateAction<string>>
  sendMessageLoader: boolean
  onSendMessage: (text: string) => void
  onFileSelect?: (files: File[]) => void
  uploadRef: RefObject<HTMLInputElement | null>
}

export default function TournamentChatInput({
  className,
  id = 'message',
  placeholder,
  inputText,
  setInputText,
  onSendMessage,
  onFileSelect,
  uploadRef,
  sendMessageLoader,
}: MessageInputProps) {
  const [showPicker, setShowPicker] = useState(false)
  const pickerRef = useRef<HTMLDivElement>(null)

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputText(event.target.value)
  }

  const onKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      handleSendClick()
    }
  }

  const handleSendClick = () => {
      onSendMessage(inputText)
    
  }

  const handleEmojiClick = (data: any) => {
    setInputText((prev) => prev + data?.emoji)
  }

  const onFileSelection = (event: ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files || [])
    if (files.length && onFileSelect) {
      onFileSelect(files) 
    }
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target as Node)
      ) {
        setShowPicker(false)
      }
    }

    if (showPicker) {
      document.addEventListener('mousedown', handleClickOutside)
    }
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [showPicker])

  return (
    <div id={`${id}-input`} className={clsx("card-bracket", className)}>
      <div className={"container-bracekt"}>
        <div onClick={() => setShowPicker(!showPicker)}>
          <SmileEmoji fontSize={24} />
        </div>

        {showPicker && (
          <div className={"pickerWrapper"} ref={pickerRef}>
            <EmojiPicker
              onEmojiClick={handleEmojiClick}
              searchDisabled={true}
            />
          </div>
        )}

        <div className={"inputWrapper"}>
          <input
            placeholder={placeholder ?? 'Write a message...'}
            className={"input"}
            value={inputText}
            onKeyDown={onKeyDown}
            onChange={handleInputChange}
          />
        </div>

        <div className={"rightButtons"}>
          <div onClick={() => uploadRef.current?.click()}>
            <AttachFile fontSize={24} />
          </div>
          {sendMessageLoader ? (
            <div onClick={handleSendClick}>
              <Loader />
            </div>
          ) : (
            <div onClick={handleSendClick}>
              <SendBold fontSize={'2.4rem'} />
            </div>
          )}
        </div>
      </div>

      <input
        onChange={onFileSelection}
        onClick={(event) => ((event.target as HTMLInputElement).value = '')}
        type='file'
        style={{ display: 'none' }}
        ref={uploadRef as React.Ref<HTMLInputElement>}
        accept='image/*'
        multiple
      />
    </div>
  )
}
